var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 2H9.8C13 2 15 4 15 7.2V11.25H8.75C8.34 11.25 8 11.59 8 12C8 12.41 8.34 12.75 8.75 12.75H15V16.8C15 20 13 22 9.8 22H7.21C4.01 22 2.01 20 2.01 16.8V7.2C2 4 4 2 7.2 2Z",
    fill: "#A9B7BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4405 11.25L17.3705 9.18C17.2205 9.03 17.1505 8.84 17.1505 8.65C17.1505 8.46 17.2205 8.26 17.3705 8.12C17.6605 7.83 18.1405 7.83 18.4305 8.12L21.7805 11.47C22.0705 11.76 22.0705 12.24 21.7805 12.53L18.4305 15.88C18.1405 16.17 17.6605 16.17 17.3705 15.88C17.0805 15.59 17.0805 15.11 17.3705 14.82L19.4405 12.75H15.0005V11.25H19.4405Z",
    fill: "#A9B7BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d1ea05f006d8f154f4e2f9e9437c7854.svg";
export { ForwardRef as ReactComponent };